import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    downloadTemplate: {
        id: 'iaso.user.label.downloadTemplate',
        defaultMessage: 'Download template',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    confirm: {
        id: 'iaso.mappings.confirm',
        defaultMessage: 'Confirm',
    },
    close: {
        id: 'iaso.label.close',
        defaultMessage: 'Close',
    },
});

export default MESSAGES;
